/**
 * @generated SignedSource<<7648391b8de4ac887295688e41a4af1f>>
 * @relayHash 536bd75db3cd2df747c3923dbbdfb5dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a306fd79e49849de127258c16f0e3c415f73f67ee0a405b5bc08ec6ef1826cb1

import type { ConcreteRequest } from 'relay-runtime';
export type PromptPopupCreateContentInlineMutation$variables = {
  createdInContentId: string;
  spaceKey?: string | null;
  type: string;
};
export type PromptPopupCreateContentInlineMutation$data = {
  readonly createContentInline: {
    readonly id: string | null;
  } | null;
};
export type PromptPopupCreateContentInlineMutation = {
  response: PromptPopupCreateContentInlineMutation$data;
  variables: PromptPopupCreateContentInlineMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "createdInContentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "createdInContentId",
            "variableName": "createdInContentId"
          },
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
          },
          {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "createContentInline",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PromptPopupCreateContentInlineMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PromptPopupCreateContentInlineMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "536bd75db3cd2df747c3923dbbdfb5dd",
    "id": "a306fd79e49849de127258c16f0e3c415f73f67ee0a405b5bc08ec6ef1826cb1",
    "metadata": {},
    "name": "PromptPopupCreateContentInlineMutation",
    "operationKind": "mutation",
    "text": "mutation PromptPopupCreateContentInlineMutation($createdInContentId:ID!,$spaceKey:String,$type:String!){createContentInline(input:{createdInContentId:$createdInContentId,spaceKey:$spaceKey,type:$type}){id}}"
  }
};
})();

(node as any).hash = "7e424a27911cd9ea50caa4b8ef0b5877";

export default node;
